import React from 'react'
import './Sync.scss'

const Sync = () => {
  return (
    <div>Sync</div>
  )
}

export default Sync